import { render, staticRenderFns } from "./TalentView.vue?vue&type=template&id=288bac7a"
import script from "./TalentView.vue?vue&type=script&lang=js"
export * from "./TalentView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports